<div class="mx-1 card5 shadow  flex  ">

    <div class="p-1 custom-input-container line3">
        <i class="me-2 " data-feather="truck" [size]="20"></i>
        <h5 class="mb-0 size18">Informations logistiques</h5>

    </div>

    <div *ngIf="showEmptyStockAlert" class="alert alert-warning py-2 px-3 mx-2 mb-2" role="alert">
        <i class="bi bi-exclamation-triangle-fill me-1"></i>
        Stock total nul : une alerte est activée pour ce produit (quantité totale = 0).
    </div>

    <div>
        <table class="table-responsive">
            <tbody>
            <tr>
                <th>Stock</th>
                <td>{{ entrepotName || '—' }}</td>
            </tr>
            <tr>
                <th>Quantité</th>
                <td>{{ totalQuantity !== null ? totalQuantity : '—' }}</td>
            </tr>
            <tr>
                <th>Quantité min</th>
                <td>{{ productData.informations_logistique?.[0]?.minimum || '—' }}</td>
            </tr>
            <tr>
                <th>Quantité max</th>
                <td>{{ productData.informations_logistique?.[0]?.maximum || '—' }}</td>
            </tr>
            </tbody>
        </table>


    </div>

</div>
